import { useMemo } from "react";
import {useAppSelector} from "hooks/useAppSelector";

export interface ProviderItem {
    icon: string;
    games: number;
    providerName: string;
    id: number;
    whiteImageFilter?: boolean;
}

export const providerListOrginal: ProviderItem[] = [
    {
        icon: "/img/cards/providers/Evolution.svg",
        games: 1,
        providerName: "Evolution",
        id: 10,
    },
    { icon: "/img/cards/providers/Hacksaw.svg", games: 1, providerName: "Hacksaw", id: 68 },
    { icon: "/img/cards/providers/BGaming.svg", games: 1, providerName: "BGaming", id: 3 },
    { icon: "/img/cards/providers/Relax.svg", games: 1, providerName: "Relax", id: 121 },
    { icon: "/img/cards/providers/pragmaticplay.svg", games: 1, providerName: "pragmaticplay", id: 75 },
    { icon: "/img/cards/providers/Fantasma.svg", games: 1, providerName: "Fantasma", id: 108 },
    { icon: "/img/cards/providers/Quickspin.svg", games: 1, providerName: "Quickspin", id: 34 },
    { icon: "/img/cards/providers/Netent.svg", games: 1, providerName: "Netent", id: 11 },
    { icon: "/img/cards/providers/Thunderkick.svg", games: 1, providerName: "Thunderkick", id: 35 },
    { icon: "/img/cards/providers/Habanero.svg", games: 1, providerName: "Habanero", id: 18 },
    { icon: "/img/cards/providers/Wazdan.svg", games: 1, providerName: "Wazdan", id: 36 },
    { icon: "/img/cards/providers/Amigo.svg", games: 1, providerName: "Amigo", id: 213 },
    { icon: "/img/cards/providers/Avatar.svg", games: 1, providerName: "Avatar UX", id: 44 },
    { icon: "/img/cards/providers/Betsoft.svg", games: 1, providerName: "Betsoft", id: 23 },
    { icon: "/img/cards/providers/BigTimeGaming.svg", games: 1, providerName: "Big Time Gaming", id: 13 },
    { icon: "/img/cards/providers/NoLimitCity.svg", games: 1, providerName: "No Limit City", id: 14 },
    { icon: "/img/cards/providers/Bullshark.svg", games: 1, providerName: "Bullshark", id: 222 },
    { icon: "/img/cards/providers/PrintStudios.svg", games: 1, providerName: "Print Studios", id: 120 },
    { icon: "/img/cards/providers/PushGaming.svg", games: 1, providerName: "Push Gaming", id: 94 },
    { icon: "/img/cards/providers/Popiplay.svg", games: 1, providerName: "Popiplay", id: 144 },
    { icon: "/img/cards/providers/PragmaticLive.svg", games: 1, providerName: "Pragmatic Live", id: 78 },
    { icon: "/img/cards/providers/PlaynGo.svg", games: 1, providerName: "Play'n Go", id: 6 },
    { icon: "/img/cards/providers/Spinomenal.svg", games: 1, providerName: "Spinomenal", id: 227 },
    { icon: "/img/cards/providers/NoLimitCity.svg", games: 1, providerName: "NolimitCity", id: 14 },

    // TODO: Need real ID
    { icon: "/img/cards/providers/BluePrintGaming.svg", games: 1, providerName: "Blue Print Gaming", id: 1028 },
    { icon: "/img/cards/providers/FourLeaf.svg", games: 1, providerName: "Four Leaf Gaming", id: 1030 },
    { icon: "/img/cards/providers/Octoplay.svg", games: 1, providerName: "Octoplay", id: 1032 },
    { icon: "/img/cards/providers/PocketGamesSoft.svg", games: 1, providerName: "Pocket Games Soft", id: 1033 },
    { icon: "/img/cards/providers/Slotmill.svg", games: 1, providerName: "Slot Mill", id: 1039 },
    { icon: "/img/cards/providers/TrueLab.svg", games: 1, providerName: "True Lab", id: 1041 },

    // legacy logo
    { icon: "/img/cards/providers/legacy/Booming.png", games: 1, providerName: "Booming", id: 85 },
    { icon: "/img/cards/providers/legacy/Swintt.png", games: 1, providerName: "Swintt", id: 79 },
    { icon: "/img/cards/providers/legacy/Playtech.png", games: 1, providerName: "Playtech", id: 119 },
    { icon: "/img/cards/providers/legacy/Turbo.png", games: 1, providerName: "Turbo Games", id: 150 },
    { icon: "/img/cards/providers/legacy/Kalamba.png", whiteImageFilter: true, games: 1, providerName: "Kalamba", id: 5 },
    { icon: "/img/cards/providers/legacy/Endorphina.png", games: 1, providerName: "Endorphina", id: 134 },
    { icon: "/img/cards/providers/legacy/NetGame.png", games: 1, providerName: "Netgame", id: 72 },
    { icon: "/img/cards/providers/legacy/Highfive.png", games: 1, providerName: "Highfive", id: 136 },
    { icon: "/img/cards/providers/legacy/1spin4win.png", games: 1, providerName: "1spin4win", id: 104 },
    { icon: "/img/cards/providers/legacy/Yggdrasil.png", games: 1, providerName: "Yggdrasil", id: 30 },
    { icon: "/img/cards/providers/legacy/Playson.png", games: 1, providerName: "Playson", id: 76 },
    { icon: "/img/cards/providers/legacy/Platipus.png", games: 1, providerName: "Platipus", id: 7 },
    { icon: "/img/cards/providers/legacy/Mascot.png", games: 1, providerName: "Mascot", id: 32 },
    { icon: "/img/cards/providers/legacy/Redtiger.png", games: 1, providerName: "Redtiger", id: 12 },
    { icon: "/img/cards/providers/legacy/Amatic.png", games: 1, providerName: "Amatic", id: 81 },
    { icon: "/img/cards/providers/legacy/Mancala.png", games: 1, providerName: "Mancala", id: 71 },
    { icon: "/img/cards/providers/legacy/Golden-Hero.png", games: 1, providerName: "Golden Hero", id: 89 },
    { icon: "/img/cards/providers/legacy/Onlyplay.png", games: 1, providerName: "Onlyplay", id: 27 },
    { icon: "/img/cards/providers/legacy/Gamzix.png", games: 1, providerName: "Gamzix", id: 29 },
    { icon: "/img/cards/providers/legacy/GameArt.png", games: 1, providerName: "GameArt", id: 4 },
    { icon: "/img/cards/providers/legacy/Ezugi.png", games: 1, providerName: "Ezugi", id: 17 },
    { icon: "/img/cards/providers/legacy/Evoplay.png", games: 1, providerName: "Evoplay", id: 22 },
    { icon: "/img/cards/providers/legacy/Spade.png", games: 1, providerName: "Spade Gaming", id: 149 },
];

export const useProvidersData = () => {
    const brandList = useAppSelector((state) => state.game.brandList);
    const providersData = useMemo(() => {
        const res = providerListOrginal
            .filter((itemA) => brandList.some((itemB) => itemB.brandId === itemA.id))
            .map((itemA) => {
                const matchedBrand = brandList.find((itemB) => itemB.brandId === itemA.id);
                if (matchedBrand) {
                    return { ...itemA, games: matchedBrand.brandAmount };
                }
                return itemA;
            });
        return res;
    }, [brandList]);

    return { providersData };
};

